/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  CategoryConfigurationDefinitionResponseCollectionResponse,
  Condition,
  ErrorResponse,
  Sorting,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class CategoryConfigurationDefinitions<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags CategoryConfigurationDefinitions
   * @name CategoryConfigurationDefinitionsList
   * @request GET:/CategoryConfigurationDefinitions
   * @response `200` `CategoryConfigurationDefinitionResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  categoryConfigurationDefinitionsList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CategoryConfigurationDefinitionResponseCollectionResponse, ErrorResponse>({
      path: `/CategoryConfigurationDefinitions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
